import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Shield, HandHeart, Users, Info, Globe } from 'lucide-react';
import { Button } from '../ui/button';

const IdeologySection = () => {
  const { t } = useTranslation();

  const values = [
    { icon: Heart, key: 'respect' },
    { icon: Shield, key: 'security' },
    { icon: HandHeart, key: 'consent' },
    { icon: Users, key: 'safe_space' },
    { icon: Info, key: 'prevention' },
    { icon: Globe, key: 'inclusivity' },
  ];

  return (
    <section 
      className="py-16 sm:py-24 bg-[#0B0B0C]"
      data-testid="ideology-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-display text-4xl sm:text-5xl tracking-tight text-[#F5F0E8] mb-3"
          >
            {t('ideology.title')}
          </motion.h2>
          <p className="font-serif italic text-lg text-[#B9B2A8]">
            {t('ideology.subtitle')}
          </p>
          <p className="font-display text-xl text-[#C9A84C] mt-4 tracking-wider">
            {t('ideology.slogan')}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {values.map((value, index) => (
            <motion.div
              key={value.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 card-hover"
            >
              <div className="w-10 h-10 rounded-full bg-[#C9A84C]/20 flex items-center justify-center mb-4">
                <value.icon className="w-5 h-5 text-[#C9A84C]" />
              </div>
              <h3 className="font-display text-lg text-[#F5F0E8] mb-2">
                {t(`ideology.${value.key}`)}
              </h3>
              <p className="text-sm text-[#B9B2A8] leading-relaxed">
                {t(`ideology.${value.key}_desc`)}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Link to="/ideologie">
            <Button 
              variant="outline"
              className="border-[#C9A84C]/30 text-[#C9A84C] hover:bg-[#C9A84C]/10 font-display uppercase tracking-wider"
              data-testid="ideology-cta"
            >
              En savoir plus →
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IdeologySection;
